var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralLayout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('GeneralHeader')]},proxy:true},{key:"main",fn:function(){return [_c('CongratulationsContainer')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }